// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3Pv3b","selected":"Chip_selected__bCWIy"};